export class PhoneNumber {
  static countryCodes = [
    { value: '+1', label: 'USA/Canada (+1)' },
    { value: '+44', label: 'United Kingdom (+44)' },
    { value: '+49', label: 'Germany (+49)' },
    { value: '+33', label: 'France (+33)' },
    { value: '+54', label: 'Argentina (+54)' },
    { value: '+61', label: 'Australia (+61)' },
    { value: '+7', label: 'Russia (+7)' },
    { value: '+886', label: 'Taiwan (+886)' },
  ];

  public countryPrefix:   string | null;
  public phone:           string | null;

  constructor(phoneNumberAsStr: string) {
    const country = PhoneNumber.countryCodes.find(c => phoneNumberAsStr.startsWith(c.value));
    this.countryPrefix = country ? country.value : '+1';
    this.phone = country ? phoneNumberAsStr.slice(country.value.length) : phoneNumberAsStr;
  }

  public static fromString(phoneNumberAsStr: string): PhoneNumber {
    return new PhoneNumber(phoneNumberAsStr);
  }
}
